<app-header dashboard="false" *ngIf="showDefaultHeaderFooter"></app-header>
<router-outlet></router-outlet>
<app-footer dashboard="false" *ngIf="showDefaultHeaderFooter"></app-footer>